import type {
  FileLocation,
  FileItem,
  FileVersion,
  LoadFilesStartAction,
  LoadFileAction,
  AddFileLocationAction,
  LoadFilesAction,
  LoadTrashFilesAction,
  SetFileViewAction,
  RevertFileDetailsAction,
  LoadFileLocationScheduledLiveFilesAction,
  AddFileToFileLocationAction,
  SetLocationNameAction,
  SetCTIDAssetsAction,
  SetSelectedAssetsAction,
  SearchAddTableValuesAction,
  SearchUpdatedTableValuesAction,
  SetFileVersionsAction,
  ShowFolderFilesAction,
} from "@types";

/* load file actions */
export const loadFilesStart = (): LoadFilesStartAction => ({
  type: "LOAD_FILES_START",
});

export const loadFile = (file: any): LoadFileAction => ({
  type: "LOAD_FILE",
  file: file,
});

export const addFileLocation = (itemDetails: FileLocation): AddFileLocationAction => ({
  type: "ADD_FILE_LOCATION",
  itemDetails: itemDetails,
});

export const loadFileLocations = (
  fileLocations: FileLocation[],
  total: number,
  trashedFiles: FileLocation[],
  trashTotal: number,
  fileManagerBaseUrl: string,
  ctid: string,
  searchValue: string = ""
): LoadFilesAction => ({
  type: "LOAD_FILES",
  fileLocations: fileLocations,
  total: total,
  trashedFiles: trashedFiles,
  trashTotal: trashTotal,
  fileManagerBaseUrl: fileManagerBaseUrl,
  ctid: ctid,
  searchValue: searchValue,
});

export const loadTrashFiles = (trashedFiles: FileLocation[], total: number): LoadTrashFilesAction => ({
  type: "LOAD_TRASH",
  trashedFiles: trashedFiles,
  trashTotal: total,
});

export const setFileView = (fileDetail: any): SetFileViewAction => ({
  type: "SET_FILE_VIEW",
  fileName: fileDetail.fileUploadName,
  fileType: fileDetail.content_type,
  url: fileDetail.url,
  file_data: fileDetail.file_data,
});

export const revertFileDetails = (): RevertFileDetailsAction => ({
  type: "REVERT_FILE_DETAILS",
});

export const loadfileLocationScheduledLiveFiles = (
  fileLocation: string,
  scheduledLiveFiles: FileItem[]
): LoadFileLocationScheduledLiveFilesAction => ({
  type: "LOAD_FILE_LOCATION_SCHEDULE_LIVE_FILES",
  fileLocationValue: fileLocation,
  scheduledLiveFiles: scheduledLiveFiles,
});

export const addFileToFileLocation = (fileLocation: string, file: FileItem): AddFileToFileLocationAction => ({
  type: "ADD_FILE_TO_FILE_LOCATION",
  fileLocationValue: fileLocation,
  file: file,
});

export const setLocationName = (location_name: string): SetLocationNameAction => ({
  type: "SET_LOCATION_NAME",
  location_name: location_name,
});

export const setCTIDAssets = (assets: any, source_ctid: string): SetCTIDAssetsAction => ({
  type: "SET_CTID_ASSETS",
  ctidAssets: assets,
  import_source_ctid: source_ctid,
});

export const setSelectedAssets = (assets: any[]): SetSelectedAssetsAction => ({
  type: "SET_SELECTED_ASSETS",
  assetsToImport: assets,
});

export const searchAddTableValues = (searchValue: string): SearchAddTableValuesAction => ({
  type: "SEARCH_ADD_ASSETS_TABLE_VALUES",
  searchValue: searchValue,
});

export const searchUpdatedTableValues = (searchValue: string): SearchUpdatedTableValuesAction => ({
  type: "SEARCH_UPDATED_ASSETS_TABLE_VALUES",
  searchValue: searchValue,
});

export const setFileVersions = (versions: FileVersion[]): SetFileVersionsAction => ({
  type: "LOAD_FILE_VERSIONS",
  versions: versions,
});

export const showFolderFiles = (
  folderName: string,
  showFiles: boolean,
  locationType: string
): ShowFolderFilesAction => ({
  type: "SHOW_FOLDER_FILES",
  folderName,
  showFiles,
  locationType,
});
